var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.configuration.shujuchiPage == 'saas')?_c('XitongduijieSaas',{attrs:{"IfShow":_vm.IfShow},on:{"changeIfShow":_vm.changeIfShow,"importData":_vm.saasImportData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }